// [factorem-grace-ask] "Ask Grace" page: the Grace app's /ask page in an
// iframe that fills the dashboard content area.
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';
import AskGrace from './pages/AskGrace.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/grace/ask'),
    name: 'factorem_grace_ask',
    component: AskGrace,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
